import { createSelector } from 'reselect'

export default createSelector(
	[state => state.matchingPairsCt.isModified],
	isModified => isModified
)
